module.exports = __webpack_public_path__ + "static/media/im_1.64a901e0.JPG";